<button
  type="button"
  class="hd-cycle-section-header"
  [style.--section-color]="color()"
  [attr.aria-expanded]="expanded()"
  (click)="toggle.emit()"
>
  @if (faIcon()) {
    <i class="fas fa-{{ faIcon() }} hd-cycle-section-header__icon" aria-hidden="true"></i>
  }
  <span class="hd-cycle-section-header__text">
    <span class="hd-cycle-section-header__title">{{ title() }}</span>
    @if (brings()) {
      <span class="hd-cycle-section-header__brings">
        {{ bringsLabel() }} <span [innerHTML]="brings()"></span>
      </span>
    }
  </span>
  <i
    class="fas fa-chevron-right hd-cycle-section-header__chevron"
    [class.hd-cycle-section-header__chevron--open]="expanded()"
    aria-hidden="true"
  ></i>
</button>
